import axios from 'axios';
import CustomButton from 'components/shared/CustomButton/CustomButton';
import CustomPassword from 'components/shared/CustomPassword/CustomPassword';
import CustomTextField from 'components/shared/CustomTextField/CustomTextField';
import { Formik } from 'formik';
import { Form, useNavigate } from 'react-router-dom';
import RoutePaths from 'routes/RoutePaths';
import { AuthService } from 'service/auth.service';
import zeplinColor from 'theme/Color';
import { SetNewPasswordSchema } from '../utils';
import ValidationChecklist from '../ValidationChecklist';
import { InitialValuesI } from './types';
import { generateInitialValues } from './utils';

const SetNewPasswordForm = () => {
  const navigate = useNavigate();

  const handleSubmit = async (
    values: InitialValuesI,
    setFieldError: (field: string, message: string | undefined) => void,
  ) => {
    const session = sessionStorage.getItem('challenge-session');
    const { email, password } = values;

    try {
      if (session && email) {
        await AuthService.respondToChallenge({
          userName: email,
          newPassword: password,
          session,
        });
        navigate(RoutePaths.WelcomeAboard);
      }

      sessionStorage.removeItem('challenge-session');
      sessionStorage.removeItem('email');
    } catch (error) {
      if (axios.isAxiosError(error)) setFieldError('confirm', error?.response?.data);
      console.error(error);
    }
  };

  return (
    <Formik
      initialValues={generateInitialValues()}
      onSubmit={(values, { setFieldError }) => handleSubmit(values, setFieldError)}
      validationSchema={SetNewPasswordSchema}
    >
      {({ errors, handleSubmit, handleChange, handleBlur, touched, values, isValid, dirty }) => {
        const isFormValid = dirty && isValid;

        return (
          <Form
            onSubmit={handleSubmit}
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: '20px',
              margin: '0 auto',
              width: '50%',
            }}
          >
            <CustomTextField
              name={'email'}
              required
              label={'Email'}
              type={'text'}
              text={values.email}
              onChange={handleChange}
            />

            <CustomPassword
              label={'New Password'}
              name='password'
              onChange={handleChange}
              onBlur={handleBlur}
              text={values.password}
            />

            <ValidationChecklist password={values.password} />

            <CustomPassword
              label={'Confirm New Password'}
              name='confirm'
              onChange={handleChange}
              text={values.confirm}
              error={errors.confirm && touched ? errors.confirm : ''}
            />

            <CustomButton
              disabled={!isFormValid}
              onClick={handleSubmit}
              variant='contained'
              color={isFormValid ? 'primary' : 'customDisable'}
              style={{
                borderRadius: '14px',
                height: 56,
                '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
              }}
              textStyle={{ color: isFormValid ? zeplinColor.Neutral1 : zeplinColor.Neutral8 }}
              text={'Set Password'}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default SetNewPasswordForm;
